<template lang="html">
  <div ref="fragen" class="aha-row clickable">
    <p class="fold" @click="show = !show" :class="{ show: show }" v-if="this.$route.name !== 'english'" v-html="formatDate(post.time) + ', ' + formatStage(post.stage)"></p>
    <p class="fold" @click="show = !show" :class="{ show: show }" v-else v-html="formatDate(post.time) + 'h, ' + formatStage(post.stage)"></p>
    <p class="click" @click="show = !show" v-html="post.speaker"></p>
    <p class="click" @click="show = !show" v-html="post.occupation"></p>
    <div class="read-more" v-if="show">
      <img v-if="post.files.length > 0" :src="post.files[0].url" :alt="post.title">
      <div class="more-text small">
        <div v-html="post.text"></div>
        <div class="speaker-lang small" v-html="post.language_text"></div>
      </div>
    </div>
    <div ref="fragens" class="ahafrage">
      <h2 v-html="post.title"></h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fragen',
  props: {
    post: Object
  },
  data() {
    return {
      show: false
    }
  },
  created() {
    window.addEventListener('scroll', this.inViewport)
  },
  destroyed() {
    window.removeEventListener('scroll', this.inViewport)
  },
  methods: {
    inViewport() {
      let hW = window.innerHeight / 2
      let center = window.scrollY + hW
      let top = this.$refs.fragen.offsetTop - 4
      let height = top + this.$refs.fragen.clientHeight + 4
      if (center > top && center < height) {
        this.$refs.fragen.classList.add('active')
      } else {
        this.$refs.fragen.classList.remove('active')
      }
    },
    formatDate(str) {
      let time = str.slice(11, 13)
      let minutes = str.slice(14, 16)
      if (minutes !== '00') {
        time = time + 'h' + minutes
      } else {
        time = time + 'h'
      }
      // console.log(minutes)
      return time
    },
    formatStage(str) {
      let newStage
      if (str === 'stage1') {
        newStage = 'Grosse Halle'
      }
      if (str === 'stage2') {
        newStage = 'Mittlere Halle'
      }
      if (str === 'stage3') {
        newStage = 'Shedhalle'
      }
      if (str === 'stage4') {
        newStage = 'Club'
      }
      if (str === 'stage5') {
        newStage = 'Probebühne'
      }
      return newStage
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/base';

.read-more {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    // justify-content: flex-end;
    .speaker-lang {
        padding-top: $gap / 2;
        flex: 0 0 100%;
        @media only screen and (min-width:600px) {
            font-size: $font-size / 3;
            flex: 0 0 70%;
        }
    }
    img {
        // flex:0 0 30%;
        padding-right: $gap / 2;
        height: auto;
        @media only screen and (max-width: 600px) {
            padding-right: 0;
        }
    }
    .more-text {
        padding-top: 4rem;
        flex: 1 0 70%;
    }
}
</style>
